import { getDefaultData } from './get-default-data';
import { navigation } from '@exploration/cms-constants';

const cmsData = getDefaultData();
const adviceServicesLinks = [
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .advice_services_free_money_coaching
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .advice_services_dedicated_planning
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .advice_services_managed_accounts
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links.advice_services_personal_trust
  ],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const financialGoalsLinks = [
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .financial_goals_starting_out_financially
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .financial_goals_balancing_work_and_family
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .financial_goals_nearing_retirement
  ],
  cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .financial_goals_living_in_retirement
  ],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const bankingNavigationalLink = {
  label:
    cmsData.callToAction?.[
      navigation.financial_advice_navigation_links
        .working_with_a_financial_advisor
    ].text,
  url: cmsData.callToAction?.[
    navigation.financial_advice_navigation_links
      .working_with_a_financial_advisor
  ].href,
};

const promoCard = {
  title:
    cmsData?.text?.[
      navigation.financial_advice_promo_card.financial_advice_promo_card_title
    ],
  description:
    cmsData?.text?.[
      navigation.financial_advice_promo_card
        .financial_advice_promo_card_description
    ],
  callToAction: {
    label:
      cmsData?.callToAction?.[
        navigation.financial_advice_promo_card
          .financial_advice_promo_card_call_to_action
      ].text,
    url: cmsData?.callToAction?.[
      navigation.financial_advice_promo_card
        .financial_advice_promo_card_call_to_action
    ].href,
  },
};

export const financialAdviceLinks = {
  adviceServicesLinks,
  financialGoalsLinks,
  bankingNavigationalLink,
  promoCard,
};
